import { takeLatest, call, put } from 'redux-saga/effects';
import axiosInstance from '../../services/AuthHeader';
import { selectUserId } from '../reducers/session';
import { setSending, unsetSending } from '../reducers/serverCommunication';

export const SAGA_CLIENT_ANALYTICS = 'SAGA_CLIENT_ANALYTICS';
export const sendClientAnalytics = (clientAnalyticsData) => {
  return {
    type: SAGA_CLIENT_ANALYTICS,
    clientAnalyticsData,
  };
};

const handleSendClientAnalytics = async ({
  action,
  actionParameters,
  category,
  appName,
  appVersion,
  clientCreated,
  clientDeviceIdentifier,
  clientDeviceModel,
  clientOsVersion,
  clientPlatform,
  clientScreenSize,
}) =>
  axiosInstance.post('/api/audit/client_analytics', {
    action,
    actionParameters,
    category,
    appName,
    appVersion,
    clientCreated,
    clientDeviceIdentifier,
    clientDeviceModel,
    clientOsVersion,
    clientPlatform,
    clientScreenSize,
  });

export function* sendClientAnalyticsSaga(action) {
  yield put(setSending);
  try {
    action.clientAnalyticsData.userId = yield selectUserId;
    yield call(handleSendClientAnalytics, action.clientAnalyticsData);
  } catch (error) {
    console.log(error);
  } finally {
    yield put(unsetSending);
  }
}

export function* watchForClientAnalytics() {
  yield takeLatest(SAGA_CLIENT_ANALYTICS, sendClientAnalyticsSaga);
}
